import { render, staticRenderFns } from "./storeMethod.vue?vue&type=template&id=ca6e53a4&scoped=true&"
import script from "./storeMethod.vue?vue&type=script&lang=js&"
export * from "./storeMethod.vue?vue&type=script&lang=js&"
import style0 from "./storeMethod.vue?vue&type=style&index=0&id=ca6e53a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca6e53a4",
  null
  
)

component.options.__file = "storeMethod.vue"
export default component.exports